import React, { useState, useRef, useEffect } from 'react';
import { Map, TileLayer, FeatureGroup, GeoJSON } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import proj4 from 'proj4';
import L from 'leaflet';
import { Form, message, Card,Spin } from 'antd';
import axios from 'axios';
import * as reactstrp from 'reactstrap';
import 'leaflet-geometryutil';
import * as serverconfig from '../serverconn'
import { string } from 'prop-types';
var CryptoJS = require("crypto-js");

const FormItem = Form.Item;


const All_licence_map = (props) => {
    const mapRef = useRef(); // Create a ref for the map
    const [existing_licences, setexisting_licences] = useState([]);
    const [map_boundary, setmap_boundary] = useState({});
    const [data_loading, setdata_loading] = useState(true);

    

    // Helper function to convert WKT to GeoJSON
    const parseGeometry = (wkt) => {
        // Remove SRID=XXXX; prefix if present
        const wktWithoutSrid = wkt.replace(/SRID=\d+;/, '');
    
        let coordinates = [];
    
        if (wktWithoutSrid.startsWith('POLYGON')) {
            // Handle POLYGON geometry
            coordinates = wktWithoutSrid
                .replace('POLYGON ((', '')
                .replace('))', '')
                .split(', ')
                .map(pair => pair.split(' ').map(Number)); // Convert to number
    
            return {
                type: 'Polygon',
                coordinates: [coordinates] // GeoJSON expects a nested array for polygons
            };
        } else if (wktWithoutSrid.startsWith('LINESTRING')) {
            // Handle LINESTRING geometry (for polylines)
            coordinates = wktWithoutSrid
                .replace('LINESTRING (', '')
                .replace(')', '')
                .split(', ')
                .map(pair => pair.split(' ').map(Number)); // Convert to number
    
            return {
                type: 'LineString',
                coordinates: coordinates // GeoJSON format for LineString
            };
        }
    
        throw new Error('Unsupported WKT geometry type');
    };


    useEffect(() => {


        //get juridetails
        axios.get(serverconfig.backendserverurl+`/customqueries/get_default_jurisdiction`)
        .then(response => {
            //console.log(response.data)
            //setShapes(response.data);
            //console.log('API Response:', JSON.stringify(response.data.data)); // Debugging
            // Ensure data is an array; if it's a FeatureCollection, extract the features array
            const features1 = response.data.data.features.map(feature => ({
                ...feature,
                geometry:parseGeometry(feature.geometry) // Convert WKT to GeoJSON
            }));

            //console.log("Jury obj "+JSON.stringify(features1[0]))

            //set jurisdiction
            setmap_boundary(features1[0])

        })
        .catch(error => {
            console.error('Error fetching shapes', error);
        });



        axios.get(serverconfig.backendserverurl+`/customqueries/get_all_spartial_data`)
        .then(response => {

            //setShapes(response.data);
            //console.log('API Response:', JSON.stringify(response.data.data)); // Debugging
            // Ensure data is an array; if it's a FeatureCollection, extract the features array
            const features = response.data.data.features.map(feature => ({
                ...feature,
                geometry: parseGeometry(feature.geometry) // Convert WKT to GeoJSON
            }));
            setexisting_licences(features);

            //set dataloading
            setdata_loading(false)


        })
        .catch(error => {
            console.error('Error fetching shapes', error);
        });








        if (mapRef.current) {
            const map = mapRef.current.leafletElement;
            const boundaryLayer = L.geoJSON(props.map_boundary);
            boundaryLayer.addTo(map);
        }
    }, []);


        // Function to bind popups with shape information
        const onEachFeature = (feature, layer) => {
        if (feature.properties) {
            layer.bindPopup(`
                <strong>Description:</strong>Area:  ${feature.properties.calculated_area} Km2 & length: ${feature.properties.length} Km<br />
                <strong>SRID:</strong> ${feature.properties.srid}<br />
                <strong>Area:</strong> ${feature.properties.calculated_area} Km2<br />
                <strong>Length:</strong> ${feature.properties.length} meters<br />
            
                <strong>Status:</strong> ${feature.properties.license__status} <br />
                <strong>Grant Date:</strong> ${feature.properties.license__grant_date} <br />
                <strong>Expiry Date:</strong> ${feature.properties.licence_expiry_date} <br />
            
            
                `);
        }
    };


    if (data_loading){
        return (
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin size="large">
          <div className="content" />
        </Spin>      
         </div>
        )
    }else{
        return (

            <div style={{ display: 'flex', flexDirection: 'column', width: '100%',overflowX:'auto'  }}>
                <Map center={[1.3733, 32.2903]} zoom={7} style={{ height: '500px', width: '100%' ,overflowX:'auto'}} ref={mapRef}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution="&copy; OpenStreetMap contributors"
                    />
                    <FeatureGroup>
    
    
                        {/* Add Uganda boundary to the map */}
                        {JSON.stringify(map_boundary)!="{}"?
                         <GeoJSON data={map_boundary} />
                        :null
                        }
    
                        {/**Add existing
                         * 
                         * 
                         * 
                         * 
                         * 
                         *  licences */}
    
                        {existing_licences.length > 0 && (
                            <GeoJSON
                                data={{ type: 'FeatureCollection', features: existing_licences }}
                                onEachFeature={onEachFeature}
                                
                                style={(feature) => ({
                                    fillColor: feature.properties.spartial_shape_background_color || '#3388ff', // Default fill color
                                    color: feature.properties.spartial_shape_border_color || '#000000', // Default border color
                                    weight: 2, // Border thickness
                                    opacity: 1, // Border opacity
                                    fillOpacity: 0.7, // Fill opacity
                                })}
    
                            />
                        )}
    
    
                    </FeatureGroup>
                </Map>
    
              
            </div>
        );

    }
  
 


};

export default All_licence_map;
